import React, {useEffect, useState} from 'react';
import {auth, getFirebaseErrorMessage} from '../../utils/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../context/LanguageContext';
import Lottie from 'lottie-react';
import loadingAnimation from '../../lotties/loading_ball.json';
import BackButton from "../../components/BackButton";
import {useAuth} from "../../context/AuthContext";
import {trackRegisterButtonClick} from "../../utils/tracking";

const AccountPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loadingLogin, setLoadingLogin] = useState(false);
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { t, language } = useLang();

    useEffect(() => {
        if(currentUser){
            navigate('/account');
        }
    }, [currentUser, navigate]);

    const handleLogin = async () => {
        try {
            setLoadingLogin(true);
            await signInWithEmailAndPassword(auth, email, password);
            window.location.href = '/account';
        } catch (error) {
            console.error(error);
            console.error(error.message);
            console.error(error.code);
            alert(getFirebaseErrorMessage(error.code, language));
        } finally {
            setLoadingLogin(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 relative">
            <BackButton onClick={() => navigate('/')} />

            <h1 className="mb-4 text-xl font-bold">{t('txt.myAccountTitle')}</h1>

            {loadingLogin ? (
                // Lottie Animation while logging in
                <div className="flex flex-col items-center">
                    <Lottie
                        animationData={loadingAnimation}
                        style={{ width: 150, height: 150 }}
                    />
                    <p className="text-sm text-gray-500">{t('txt.pleaseWait')}</p>
                </div>
            ) : (
                <>
                    <div className="w-64 mb-4">
                        <input
                            type="email"
                            placeholder={t('txt.email')}
                            className="w-full mb-2 px-3 py-2 border rounded"
                            value={email}
                            onChange={(e)=> setEmail(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder={t('txt.password')}
                            className="w-full mb-2 px-3 py-2 border rounded"
                            value={password}
                            onChange={(e)=> setPassword(e.target.value)}
                        />
                    </div>

                    <div className="flex flex-col space-y-2 w-64 mb-4">
                        <button
                            onClick={handleLogin}
                            className="px-4 py-2 bg-[#34495e] text-white rounded mb-6"
                        >
                            {t('btn.login')}
                        </button>
                        <button
                            onClick={() => navigate('/forgotPassword')}
                            className="px-4 py-2 bg-[#34495e] text-white rounded"
                        >
                            {t('btn.forgotPassword')}
                        </button>
                        <button
                            onClick={() => {
                                trackRegisterButtonClick();
                                navigate('/register');
                            }}
                            className="px-4 py-2 bg-[#27ae60] text-white rounded"
                        >
                            {t('btn.register')}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default AccountPage;
